import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { Store } from "@ngxs/store";

import { ConfigurationState } from "../configuration/state/configuration.state";

export type LedColor = "GREEN" | "RED" | "NEUTRAL";

@Injectable({
	providedIn: "root",
})
export class LedApiService {
	private url: string | undefined;
	private httpClient: HttpClient;

	constructor(
		private store: Store,
		private httpBackend: HttpBackend,
	) {
		// Manually create a new HttpClient to avoid any interceptors
		this.httpClient = new HttpClient(this.httpBackend);

		this.store.select(ConfigurationState.state).subscribe((state) => {
			if (state?.rootConfiguration?.ledControlUrl) {
				const sanitizedUrl = state.rootConfiguration.ledControlUrl.replace(/\/+$/, "");
				this.url = `${sanitizedUrl}/api/led/color`;
			}
		});
	}

	public set(color: LedColor): void {
		if (!this.url) {
			return;
		}

		this.httpClient.post(this.url, { color: color }).subscribe({
			next: () => {
				// ...existing code...
			},
			error: (err) => {
				console.error("Failed to set LED color:", err);
			},
		});
	}
}
